module.exports = __webpack_public_path__ + "img/enemy_121_004.23ab7655.png";